export  const trainingPrograms = [
    {
        id: 0,
        name: "Little Explorers (7 to 11 y.o.)",
        min: 7,
        max: 11
    },
    {
        id: 1,
        name: "New Adventurers (10 to 14 y.o.)",
        min: 10,
        max: 14
    },
    {
        id: 2,
        name: "Rising Learners (12 to 15 y.o.)",
        min: 12,
        max: 15
    },
    {
        id: 3,
        name: "Future Leaders (15 to 18 y.o.)",
        min: 15,
        max: 18
    }
];